<template>
<p>logout</p>
</template>

<script>
import router from "@/router";

export default {
  name: "Logout",
  methods:{
  logout(){
    localStorage.removeItem('authorization')

// Remove userData from localStorage
    localStorage.removeItem('userInfo')

    router.push('login')
  }
  },
  mounted() {
    this.logout()
  },
  data(){

  }
}





</script>

<style scoped>

</style>
